import React, { useState } from "react";
import Navigations from "../../Common/Navigations/Navigations";
import CVDownload from "./CVDownload/CVDownload";
import ThemeToggle from "../../UI/ThemeToggle/ThemeToggle";
import { Element } from "react-scroll";
import MenuIcon from "./MenuIcon/MenuIcon";
import clasess from "./Navigation.module.css";
import SideDrawal from "../SideDrawal/SideDrawal";

const Navigation = () => {
  const [toogleSideDrawal, setToogleSideDrawal] = useState(false);

  const handleSideDrawal = () => {
    setToogleSideDrawal(!toogleSideDrawal);
  };

  return (
    <Element name="Navigation">
      <div className={clasess.headerNav}>
        <div className={clasess.LeftSection}>
          <Navigations CSSstyle={clasess.NavCSS}>
            <div className={clasess.MyName}>James</div>
          </Navigations>
        </div>

        <div className={clasess.RightSection}>
          <CVDownload />
          <ThemeToggle />
        </div>

        <MenuIcon open={handleSideDrawal} status={toogleSideDrawal} />
        <SideDrawal status={toogleSideDrawal} click={handleSideDrawal} />
      </div>
    </Element>
  );
};

export default Navigation;
